"use client";

import { SourceDocumentPanelBody } from "./SourceDocumentPanelBody";

/**
 * Legacy fixed overlay for the AI source-document preview. Used as a fallback
 * in hosts that don't mount a SourceDocumentPanelProvider (the push layout).
 * Both share the same SourceDocumentPanelBody for the preview/close logic.
 */
export function SourceDocumentSlideOver({
  batchId,
  open,
  onClose,
}: {
  readonly batchId: string;
  readonly open: boolean;
  readonly onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-y-0 right-0 w-[640px] max-w-[90vw] bg-white shadow-xl border-l z-50 flex flex-col">
      <SourceDocumentPanelBody
        batchId={batchId}
        open={open}
        onClose={onClose}
      />
    </div>
  );
}
